
define("rv!templates/layout/menu",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:7,
          e:"a",
          a:{ style:"float: right;",
            href:"/login.aspx" },
          f:[ { t:7,
              e:"img",
              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/login.gif",
                alt:"Login" } } ] } ],
      n:50,
      x:{ r:[ "user" ],
        s:"_0==null" } },
    { t:4,
      f:[ { t:7,
          e:"div",
          a:{ id:"administratorPanel" },
          f:[ { t:7,
              e:"ul",
              a:{ "class":"nav nav-tabs nav-stacked" },
              f:[ { t:7,
                  e:"li",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/CallCenter/membersearch.aspx" },
                      f:[ "Operate As Member" ] } ] },
                " ",
                { t:7,
                  e:"li",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:[ "/callcenter/CRM/",
                          { t:4,
                            f:[ "?u=",
                              { t:2,
                                r:"user.member.UserID" } ],
                            n:50,
                            r:"user.isDba" } ] },
                      f:[ "Communication Logger" ] } ] },
                " ",
                { t:7,
                  e:"li",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/Callcenter/viewMemberEnrollmentProgress.aspx" },
                      f:[ "Enrollment Progress" ] } ] },
                " ",
                { t:7,
                  e:"li",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"/CallCenter/UserErrors.aspx" },
                      f:[ "View User Errors" ] } ] } ] },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"strong",
              a:{ id:"administratorPanelTab" },
              f:[ "Admin Panel" ] } ] },
        " ",
        { t:7,
          e:"div",
          a:{ style:"position: absolute; top: 0px; right: 20px;" },
          f:[ { t:4,
              f:[ { t:7,
                  e:"span",
                  a:{ style:"color: #ffffff" },
                  f:[ "Loading..." ] } ],
              n:50,
              r:"loading" },
            { t:4,
              n:51,
              f:[ { t:4,
                  f:[ { t:7,
                      e:"span",
                      a:{ style:"color: #ffffff" },
                      f:[ "Operating as ",
                        { t:2,
                          r:"user.member.NameFirst" },
                        " ",
                        { t:2,
                          r:"user.member.NameLast" } ] } ],
                  n:50,
                  r:"user.isDba" },
                { t:4,
                  n:51,
                  f:[ { t:7,
                      e:"div",
                      a:{ style:"color: red;" },
                      f:[ "NOT OPERATING AS A USER" ] } ],
                  r:"user.isDba" },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"#" },
                      v:{ click:"removeAltUser" },
                      f:[ "Remove Alt User" ] } ],
                  n:50,
                  r:"user.isDba" } ],
              r:"loading" } ] } ],
      n:50,
      x:{ r:[ "inRole" ],
        s:"_0(\"CallCenter,Admin\")" } },
    { t:7,
      e:"div",
      a:{ "class":"navbar_secondary" },
      f:[ { t:7,
          e:"div",
          a:{ "class":"menu-nav-container" },
          f:[ { t:7,
              e:"ul",
              a:{ id:"menu-nav",
                "class":"sf-menu" },
              f:[ { t:7,
                  e:"li",
                  a:{ id:"menu-item-441",
                    "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                  f:[ { t:7,
                      e:"a",
                      a:{ href:"#",
                        style:"cursor: default;" },
                      f:[ "About Adestinn",
                        { t:7,
                          e:"span",
                          a:{ "class":"menu-title" },
                          f:[ "vacation savings account" ] } ] },
                    " ",
                    { t:7,
                      e:"ul",
                      a:{ "class":"sub-menu" },
                      f:[ { t:4,
                          f:[ { t:7,
                              e:"li",
                              a:{ "class":"menu-item menu-item-type-custom menu-item-object-custom" },
                              f:[ { t:7,
                                  e:"a",
                                  a:{ href:"/#/Enroll" },
                                  f:[ "Enroll Now!" ] } ] } ],
                          n:50,
                          x:{ r:[ "user" ],
                            s:"_0==null" } },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ "class":"menu-item menu-item-type-custom menu-item-object-custom" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/hotel-new-search" },
                              f:[ "Search Destinations" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ "class":"menu-item menu-item-type-custom menu-item-object-custom" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/destinations" },
                              f:[ "List of Destinations" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ id:"menu-item-3811",
                            "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"#" },
                              v:{ click:"adestinnIn90Seconds" },
                              f:[ "Adestinn in 90 seconds" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/About" },
                              f:[ "It's Easy" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/Security" },
                              f:[ "It's Safe" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/Empowered" },
                              f:[ "It's Empowering" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ id:"menu-item-3571",
                            "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/FAQ" },
                              f:[ "FAQ" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#/hr/?tr=topmenu" },
                              f:[ "Information For Employers" ] } ] },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"li",
                              a:{ "class":"menu-item menu-item-type-post_type menu-item-object-page" },
                              f:[ { t:7,
                                  e:"a",
                                  a:{ href:"/#/hotel-info/?tr=topmenu" },
                                  f:[ "Information For Hotels" ] } ] } ],
                          n:50,
                          x:{ r:[ "hideHotelAndEmployerInfoLinks" ],
                            s:"_0()" } },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ id:"menu-item-5601",
                            "class":"menu-item menu-item-type-custom menu-item-object-custom" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#" },
                              f:[ "—————————" ] } ] },
                        " ",
                        { t:7,
                          e:"li",
                          a:{ id:"menu-item-451",
                            "class":"menu-item menu-item-type-custom menu-item-object-custom" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/#" },
                              f:[ "Adestinn Home" ] } ] } ] } ] },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"li",
                      a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                      f:[ { t:7,
                          e:"a",
                          a:{ href:"#",
                            style:"cursor: default;" },
                          f:[ "My Account ",
                            { t:7,
                              e:"span",
                              a:{ "class":"menu-title" },
                              f:[ "Manage your Member Account" ] } ] },
                        " ",
                        { t:7,
                          e:"ul",
                          a:{ "class":"sub-menu" },
                          f:[ { t:4,
                              f:[ { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/#/vacations" },
                                      f:[ "My Vacations" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/AccountSummary/" },
                                      f:[ "Manage Account" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/AccountSummary/" },
                                      f:[ "    Account Summary" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/ACH_Schedule.aspx" },
                                      f:[ "    Contribution Schedule" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/FinancialAccount.aspx" },
                                      f:[ "    Linked Account" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/MemberAgreement.aspx" },
                                      f:[ "    View Member Agreement" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount" },
                                      f:[ "    Personal Information" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/myaccount/preferences" },
                                      f:[ "    Notification Preferences" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/Default.aspx?cm=t" },
                                      f:[ "    Co-Member" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/ChangeUserName.aspx" },
                                      f:[ "    Change User Name" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/changepassword.aspx" },
                                      f:[ "    Change Password" ] } ] },
                                " ",
                                { t:7,
                                  e:"li",
                                  a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/MyAccount/changeSecurityQuestionAndAnswer.aspx" },
                                      f:[ "    Change Security Question and Answer" ] } ] } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"Member,Admin,CallCenter\")" } },
                            " ",
                            { t:4,
                              f:[ { t:4,
                                  n:53,
                                  f:[ { t:8,
                                      r:"menuitem" } ],
                                  x:{ r:[  ],
                                    s:"{url:\"/admin\",text:\"Admin\"}" } } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"Admin\")" } },
                            " ",
                            { t:4,
                              f:[ { t:4,
                                  n:53,
                                  f:[ { t:8,
                                      r:"menuitem" } ],
                                  x:{ r:[  ],
                                    s:"{url:\"/callcenter\",text:\"Call Center\"}" } } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"CallCenter,HelpDesk\")" } },
                            " ",
                            { t:4,
                              f:[ { t:4,
                                  n:53,
                                  f:[ { t:8,
                                      r:"menuitem" } ],
                                  x:{ r:[  ],
                                    s:"{url:\"/hotel/changepassword.aspx\",text:\"Change Password\"}" } } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"Hotel\")" } },
                            " ",
                            { t:4,
                              f:[ { t:4,
                                  n:53,
                                  f:[ { t:8,
                                      r:"menuitem" } ],
                                  x:{ r:[  ],
                                    s:"{url:\"/customer\",text:\"Customer\"}" } } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"Customer\")" } },
                            " ",
                            { t:4,
                              f:[ { t:4,
                                  n:53,
                                  f:[ { t:8,
                                      r:"menuitem" } ],
                                  x:{ r:[  ],
                                    s:"{url:\"/executive\",text:\"Executive\"}" } } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"Executive,CallCenter,HelpDesk,Admin\")" } },
                            " ",
                            { t:4,
                              f:[ { t:4,
                                  n:53,
                                  f:[ { t:8,
                                      r:"menuitem" } ],
                                  x:{ r:[  ],
                                    s:"{url:\"/accountant\",text:\"Accountant\"}" } } ],
                              n:50,
                              x:{ r:[ "inRole" ],
                                s:"_0(\"Accountant,AccountantBoss,Admin\")" } },
                            " ",
                            { t:4,
                              n:53,
                              f:[ { t:8,
                                  r:"menuitem" } ],
                              x:{ r:[  ],
                                s:"{url:\"\",text:\"—————————\"}" } },
                            " ",
                            { t:4,
                              n:53,
                              f:[ { t:8,
                                  r:"menuitem" } ],
                              x:{ r:[  ],
                                s:"{url:\"/login.aspx?logout=true\",text:\"Logout\"}" } } ] } ] } ],
                  n:50,
                  x:{ r:[ "user" ],
                    s:"_0!=null" } } ] } ] } ] },
    " " ],
  p:{ menuitem:[ { t:7,
        e:"li",
        a:{ "class":"menu-item menu-item-type-taxonomy menu-item-object-category" },
        f:[ { t:7,
            e:"a",
            a:{ href:[ { t:2,
                  r:"url" } ] },
            f:[ { t:2,
                r:"text" } ] } ] } ] } };});
